<button type="button" class="" (click)="!readonly ? navigate() : ''"
    [ngClass]="{'btn btn-setting-readonly ' : readonly, 'btn btn-setting' : !readonly}">
    <fa-icon *ngIf="icon" [icon]="icon"></fa-icon>
    <i class="pi" [ngClass]="prime_icon" *ngIf="prime_icon"></i>
    {{name}}
</button>